<template>
  <div>
    <header class="demos-header">
      <h1 class="demos-title">预约记录</h1>
    </header>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row  type="flex" :gutter="16">
          <a-col :span="12">
            <a-form-item label="车号::" style="margin-top: 8px;margin-left: 18px">
              <a-input style="width: 140%" v-model="queryParam.vehicleNo" placeholder="请输入"/>
            </a-form-item>
          </a-col>
          <a-col :span="6" style="margin-left:70px;margin-top: 8px">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div>
      <a-button type="primary" :disabled="!hasSelected" @click="batchApprove"  v-if="rolelimit == true">
        批量审核
      </a-button>
      <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `已选中 ${selectedRowKeys.length} 条` }}
        </template>
      </span>
    </div>
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, selectedRows: selectedRows }"
    >
      <span slot="action" slot-scope="text, record, index">
        <a @click="toRespDetails(record)">详情</a>
      </span>
    </s-table>

    <a-modal
      title="审核设置"
      style="top: 100px"
      :width="300"
      v-model="visible"
      @ok="handleOk"
      :confirmLoading="confirmLoadings"
    >
      <a-form :form="form">
        <a-radio-group @change="onRadioChange" v-model="value">
          <a-radio :value="1">通过</a-radio>
          <a-radio :value="3">拒绝</a-radio>
        </a-radio-group>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { STable } from '@/components'
import { mapActions } from 'vuex'
import { getCorpSupplierList } from '@/api/basic'
import { reservationPage, reservationAudit } from '@/api/logistics'
import storage from "@/utils/storage"
import { findPrivileBycode } from '@/api/sys'
import weui from 'jquery-weui/dist/js/jquery-weui.min'
import { showMsg } from '@/utils/util'
import { formatDate } from '../../utils/date.js'

export default {
  name: 'respList',
  components: {
    STable
  },
  data() {
    return {
      // bizList:this.config.bizList,
      bizList: this.$store.getters.bizList,
      respList: [],
      // 查询参数,微信默认每页显示8条
      value: 1,
      queryParam: {},
      selectedRowKeys: [],
      selectedRows: [],
      visible: false,
      rolelimit: false,
      confirmLoadings: false,

      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return reservationPage(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log('reservationList', res)
            return res.data
          })
      },

      // 表头
      columns: [
        /*         {
                  title: '供应商',
                  dataIndex: 'supplierName',
                }, */
        {
          title: '货物名称',
          dataIndex: 'materielName',
        },
        {
          title: '车号',
          dataIndex: 'vehicleNo',
        },
        {
          title: '手机号',
          dataIndex: 'phone',
        },
        /*     {
              title: '司机名称',
              dataIndex: 'driverName',
            },

            {
              title: '上门日期',
              sorter: true,
              dataIndex: 'appointedDate',
              customRender: (text) => {
                const date = new Date(text)
                return formatDate(date, 'yyyy-MM-dd')
              }
            },
            {
              title: '短信发送状态',
              dataIndex: 'smsStatus',
              scopedSlots: { customRender: 'smsStatus' },
            }, */
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
    }
  },
  created() {
    this.checkButtonPrivilege()

    this.roleId = this.$store.getters.roles
    // 如果登录的用户不是供应商,目前为管理员或采购员,需要选择供应商
    if (this.roleId !== this.config.RoleType.SUPPLIER) {

    }


    // this.loadRespList()
  },
  computed: {
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },
  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      this.approveRemark = true
      console.log('selectedRowKeys changed: ', selectedRows);
      this.selectedRowKeys = selectedRowKeys;
      for (var i = 0; i < selectedRows.length; i++) {
        if (selectedRows[i].rsvStatus != 0) {
          this.approveRemark = false
        }
      }
      if (this.approveRemark == false) {
        this.$message.warning("选中的记录包含已审核记录,请重新选择", 3)
        this.selectedRowKeys = []
      }
    },
    handleOk() {
      const _this = this
      _this.confirmLoadings = true
      reservationAudit(Object.assign({}, { batchReservationId: this.selectedRowKeys, auditStatus: this.value }))
        .then(res => {
          if (res.code === '0') {
            this.selectedRowKeys = [],
            this.selectedRows = [],
            this.$refs.table.refresh()
          }
        })
        .catch(() => { })
        .finally(() => {
          _this.confirmLoadings = false
          this.visible = false
        })
    },
    batchApprove() {
      // 弹出框显示
      this.visible = true
      console.log("选中的ids:" + this.selectedRowKeys)
      this.batchReservationId = this.selectedRowKeys
    },
    //分配物流记录按钮权限
    checkButtonPrivilege(record) {

      new Promise(resolve => {
        const data = findPrivileBycode({ code: 'yyjl-handler' }).then(res => { return res.data })
        resolve(data)
      }).then(res => {

        if (res == 'yyjl-handler') {
          this.rolelimit = true
        }
      })

    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    toRespDetails(record) {
      let obj = this.bizList.find((item) => {
        return item.id === record.businessTypeId;
      });
      console.log("obj:" + obj);
      // record.materielType = obj.name
      record.businessTypeId = record.businessTypeId;


      if (record.operType) {
        let that = this
        let obj = this.config.OperTypeList.find((item) => {
          return item.id === record.operType;;
        });
        record.operType = obj.name
      }
      storage.save("cache-respInfo", JSON.stringify(record));
      this.$router.push({ name: 'wxRespDetails' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>